export default __webpack_public_path__ + "static/TiemposRegular-252d10e21e8cf5cecb7639158d89c598.woff";